import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { FooterComponent } from './components/footer/footer.component';
import { PrimeNGConfig } from 'primeng/api';
import { primeDe } from '@shared';
@Component({
  imports: [RouterModule, ToastModule, FooterComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected title = 'customer';
  primengConfig = inject(PrimeNGConfig);

  constructor() {
    this.primengConfig.ripple = true;
    this.primengConfig.setTranslation(primeDe.de);
  }
}
